import Vue from "vue"
import VueRouter from "vue-router"

// Routes
import auth from "./auth"
import dashboard from "./dashboard"
import symptomChecker from "./symptomChecker"
import pet from "./pet"

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        name: process.env.VUE_APP_RT_HOME,
        component: () => import("@/pages/Index.vue"),
        meta: {
            anon_only: true,
        },
    },
    // Dashboard Routes
    dashboard,

    // Authentication Routes - "start-sc"
    auth,

    // Symptom-checker Routes
    symptomChecker,

    // Pet Routes
    pet,
]

const router = new VueRouter({
    mode: "history", // use instead of hash to remove the hash from the url
    base: process.env.BASE_URL,
    routes,
})

// check to ensure that we have a valid session_id
router.beforeEach(async (to, from, next) => {
    // console.log(`beforeEach: ${to.name}/${from.name}`)
    const store = await import("@/store")
    var isLoggedIn = store.default.getters["auth/isLoggedIn"]

    if (to.matched.some((record) => record.meta.requiresSessionId)) {
        const validSession = store.default.getters["sc/validSession"]
        if (validSession) {
            next()
            return
        }
        console.log("invalid session, going to init - NEVER GET HERE!!!!!")
        // next({ name: process.env.VUE_APP_SYMPTOM_CHECKER_INIT })
        // next('/symptom-checker/init')
    }

    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!isLoggedIn) {
            next({
                path: "/auth/login",
                params: {nextUrl: to.fullPath},
            })
            return
        }
    }
    if (to.matched.some((record) => record.meta.anon_only)) {
        if (isLoggedIn) {
            next({name: process.env.VUE_APP_DASHBOARD_INDEX})
            return
        }
    }

    next()
})
export default router
